export default {
  "myaccount.yuzu.com" : "reader.yuzu.com"
}



/** WEBPACK FOOTER **
 ** ./src/js/utils/brands.js
 **/